<template>
  <div class="view-toggle" role="tablist" aria-label="Search mode">
    <button
      type="button"
      role="tab"
      class="view-toggle__option"
      :class="{ 'view-toggle__option--active': modelValue === 'name' }"
      :aria-selected="modelValue === 'name' ? 'true' : 'false'"
      @click="select('name')"
    >
      Search by school name
    </button>
    <button
      type="button"
      role="tab"
      class="view-toggle__option"
      :class="{ 'view-toggle__option--active': modelValue === 'filter' }"
      :aria-selected="modelValue === 'filter' ? 'true' : 'false'"
      @click="select('filter')"
    >
      Filter &amp; sort
    </button>
  </div>
</template>

<script>
export default {
  name: 'ViewToggle',
  props: {
    // 'name' | 'filter'
    modelValue: {
      type: String,
      default: 'name',
    },
  },
  emits: ['update:modelValue'],
  methods: {
    select(view) {
      if (view !== this.modelValue) {
        this.$emit('update:modelValue', view);
      }
    },
  },
};
</script>

<style scoped>
.view-toggle {
  display: inline-flex;
  padding: 4px;
  gap: 4px;
  background: var(--wash);
  border: 1px solid var(--line);
  border-radius: 999px;
}

.view-toggle__option {
  appearance: none;
  border: 0;
  cursor: pointer;
  font: inherit;
  font-size: 13px;
  font-weight: 600;
  line-height: 1.2;
  padding: 7px 14px;
  border-radius: 999px;
  color: var(--mute);
  background: transparent;
  transition: background 150ms ease, color 150ms ease;
  white-space: nowrap;
}

.view-toggle__option:hover {
  color: var(--ink);
}

.view-toggle__option:focus-visible {
  outline: 2px solid var(--ink);
  outline-offset: 2px;
}

.view-toggle__option--active,
.view-toggle__option--active:hover {
  background: var(--paper);
  color: var(--ink);
  box-shadow: var(--shadow-card);
}
</style>
